export default "__VITE_ASSET__DkeWfuDz__"